import { useEffect } from "react";
import { useRouter } from "next/router";
import { withAuthUser } from "next-firebase-auth";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useAuth } from "../components/auth/hooks/useAuth";
import { useTranslation } from "next-i18next";
// BOOTSTRAP
import { Accordion } from "react-bootstrap";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
// COMPONENTS
import BootstrapSpinner from "@/components/elements/LoadingPlaceholders/BootstrapSpinner";
import SideLinks from "@/components/core/CustomerService/SideLinks/SideLinks";
import ServiceClientsToggle from "@/components/elements/AccordionsToggles/ServiceClientsToggle";
import { NextSeo } from "next-seo";

const paymentsAccordionItems = [
  {
    title: "bank-transfer",
    menuItems: [
      {
        id: 0,
        title: "",
        text: "",
      },
    ],
  },
  {
    title: "credit-card",
    menuItems: [
      {
        id: 0,
        title: "",
        text: "",
      },
    ],
  },
  {
    title: "cash-on-delivery",
    menuItems: [
      {
        id: 0,
        title: "",
        text: "",
      },
    ],
  },
];

function Payments() {
  const auth = useAuth();
  const router = useRouter();

  const { t } = useTranslation(["payments", "db-translations"]);

  // If the user is not allowed will be redirect to homepage.
  useEffect(() => {
    if (auth.isUserSupplier()) {
      router.push("/home-supplier");
    }
  }, [[], auth]);

  return auth.isUserSupplier() ? (
    <BootstrapSpinner />
  ) : (
    <Container fluid className="px-0">
      <NextSeo
        title={t("payments")}
        description={""}
        openGraph={{
          type: "website",
          title: t("payments"),
          description: "",
          url: `${process.env.NEXT_PUBLIC_BASE_URL}/payments`,
        }}
      />
      <Row key="catalogPage" className="mx-0 px-3">
        <SideLinks />
        <Col className="px-0 px-lg-5" style={{ maxWidth: "80rem" }}>
          <div className="pb-2">
            <h1 className="fs-1 fw-semibold text-center text-md-start pb-5 text-uppercase">{t("payments")}</h1>
            <p>{t("subtitle")}</p>
            <div className="pt-1">
              {paymentsAccordionItems.map((item, index) => (
                <div className="py-2" key={index}>
                  <Accordion>
                    <ServiceClientsToggle className="text-uppercase" eventKey="0" title={t(`${item.title}.title`)} />
                    <Accordion.Collapse eventKey="0">
                      <div className="d-flex bg-white align-items-center px-3 pb-3">
                        {item.menuItems.map((menuItem, index) => (
                          <div key={index}>
                            <p>
                              <span>{t(`${item.title}.menuItems.${index}.title`)}</span>
                              <span>{t(`${item.title}.menuItems.${index}.text`)}</span>
                            </p>
                          </div>
                        ))}
                      </div>
                    </Accordion.Collapse>
                  </Accordion>
                </div>
              ))}
            </div>
          </div>
          {/* <div>
            <h1 className="fs-1">FAQ</h1>
            <div className="pt-1">
              {faqAccordionItems.map((item, index) => (
                <div className="py-2" key={index}>
                  <Accordion>
                    <ServiceClientsToggle eventKey="0" title={item.title} />
                    <Accordion.Collapse eventKey="0">
                      <div
                        className="p-3"
                        style={{
                          backgroundColor: "white",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {item.menuItems.map((subItem, index) => (
                          <div key={index}>
                            <p>
                              <span className="d-flex">{subItem.title}</span>
                              <span>{subItem.text}</span>
                            </p>
                          </div>
                        ))}
                      </div>
                    </Accordion.Collapse>
                  </Accordion>
                </div>
              ))}
            </div>
          </div> */}
        </Col>
      </Row>
    </Container>
  );
}

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common", "emails", "header", "footer", "payments", "services-side-links", "db-translations"])),
    },
  };
}

export default withAuthUser({})(Payments);
